import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function getOptionsDetails(
	modelName,
	elevation,
	callback
) {
	firebaseRef
		.ref(
			'/kavtek_buildingInfo/' +
				PROJECT_CODE.projectCode +
				'/' +
				modelName +
				'/priceList/'
		)
		.once('value', (snapshot) => {
			console.log('getOptionsDetails', snapshot.val());

			// @TODO: Continnue here...
			var priceListObj = snapshot.val();

			var priceListObjKeys = priceListObj && Object?.keys(priceListObj);

			var keyFound;

			priceListObjKeys?.forEach((key) => {
				var elevationId = priceListObj[key].id;

				if (elevationId.toLowerCase() === elevation.toLowerCase()) {
					keyFound = key;
				}
			});

			var foundObject = priceListObj?.[keyFound];

			var optionsObj = foundObject?.['options'];

			var optionArr = [];

			var optionsObjKeys = optionsObj && Object.keys(optionsObj);

			optionsObjKeys &&
				optionsObjKeys?.forEach((key) => {
					console.log('ajfasf', optionsObj[key]);
					var name = optionsObj[key]['name'];

					var price = optionsObj[key]['price'];
					var ignoreLots = optionsObj[key]['ignoreLot'];

					var image =
						optionsObj[key]['images'] &&
						optionsObj[key]['images'][0]['url'];

					var optionDetailsObj = {
						name: name,
						price: price,
						image: image,
						ignoreLot: ignoreLots,
					};

					optionArr.push(optionDetailsObj);
				});

			callback(optionArr);
		});
}
